import React from 'react';
var setDocumentOverflow = function (value) {
    if (window) {
        document.documentElement.style.overflow = value;
    }
};
export var useLockBodyScroll = function (shouldDisable) {
    if (shouldDisable === void 0) { shouldDisable = true; }
    React.useEffect(function () {
        if (shouldDisable) {
            setDocumentOverflow('hidden');
        }
        else {
            setDocumentOverflow('unset');
        }
        return function () { return setDocumentOverflow('unset'); };
    }, [shouldDisable]);
};
//# sourceMappingURL=useLockBodyScroll.js.map